import React from 'react';

import { cn } from '@/lib/utils';

const NotFound: React.FC = () => (
  <div
    className={cn(
      'h-[calc(100vh_-_theme(spacing.16))] mt-[_theme(spacing.16)]',
      'flex justify-center items-center relative',
    )}
  >
    <img src="/404.svg" alt="404" className="h-1/2 w-1/2" />
    <a
      className={cn(
        'absolute right-2 bottom-2',
        'text-muted-foreground transition-colors hover:text-foreground',
      )}
      href="https://storyset.com/web"
    >
      Web illustrations by Storyset
    </a>
  </div>
);

export default NotFound;
